import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<BbSlider\n  @range={{true}}\n  @value={{this.value}}\n  @min={{@min}}\n  @max={{@max}}\n  @step={{@step}}\n  @disabled={{@disabled}}\n  @action={{@action}}\n  @changed={{@changed}}\n  @error={{@error}}\n  @keepInRange={{@keepInRange}}\n  @immediateResponse={{@immediateResponse}}\n  @mood={{@mood}}\n  @fill={{@fill}}\n  @formatter={{@formatter}} data-test-action\n/>");

/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      component - thin range-mode wrapper that derives a default
 *              [min, max] value and renders a BbSlider with @range=true
 *   extends:   Component (@glimmer/component)
 *   template:  bb-range-slider.hbs
 *   args:      @value, @min, @max
 *   uses:      bb-slider.js (rendered by bb-range-slider.hbs as <BbSlider @range={{true}} ...>)
 *   siblings:  bb-slider.js, bb-range-slider.hbs
 *   tests:     bb-range-slider-test.js (unit)
 *   gotchas:   -
 */
class BbRangeSliderComponent extends Component {
  // Valore di default: usa i limiti effettivi del range così lo slider
  // non parte mai da una posizione fuori dal range configurato.
  get value() {
    if (this.args.value != null) return this.args.value;
    return [this.args.min ?? 0, this.args.max ?? 100];
  }
}
setComponentTemplate(TEMPLATE, BbRangeSliderComponent);

export { BbRangeSliderComponent as default };
//# sourceMappingURL=bb-range-slider.js.map
